import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { ImageMetadata, useDeleteImage } from '@/services/api/hooks/images';

import { FunctionComponent, Suspense } from 'react';
import { toast } from 'sonner';
import { Button } from '../../Button';

const extractFileName = (imageName: string) => {
  return imageName.split('assets/')[1];
};

const DeleteGalleryImageModal: FunctionComponent<ModalProps<{ image: ImageMetadata }>> = props => {
  const DeleteBundle = () => {
    const image = props.props?.image;
    if (!image) throw new Error('Missing gallery image');

    const deleteGalleryImage = useDeleteImage();

    const onDelete = async () => {
      const originalFileName = extractFileName(image.original);
      const thumbnailFileName = extractFileName(image.thumbnail);

      await deleteGalleryImage.mutateAsync({ imageName: originalFileName });
      await deleteGalleryImage.mutateAsync({ imageName: thumbnailFileName });

      toast(`${image.name} - successfully deleted`);
      props.close();
    };

    return (
      <Card className="w-full p-8 space-y-2">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-bold">Delete Image</h1>
        </Modal.Controls>

        <div className="space-y-6">
          <p>
            Are you sure you want to delete: <span className="font-semibold">{image.name}?</span>
          </p>

          <div className="flex gap-2 justify-between">
            <Button onClick={props.close}>Cancel</Button>
            <Button
              type="button"
              variant={ButtonVariant.Destructive}
              loading={deleteGalleryImage.isLoading}
              onClick={onDelete}
            >
              Delete
            </Button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <DeleteBundle />
      </Suspense>
    </Modal>
  );
};

export default DeleteGalleryImageModal;
